<template>
  <div class="header">
    <div class="container-fluid">
      <div class="card" style="margin-top: 50px">
        
        <Header :title="'My TNA'" />

        <div class="card-body">
          <SelectedPeriod :options="optionsSelectPeriod" v-model="selectedPeriod" />

          <div class="mb-3">
            <div class="row">
              <div class="col-md-4 mb-2">
                <label class="form-label">Status</label>
                <v-select
                  v-model="filters.status"
                  :options="statusOptions"
                  :reduce="option => option.value"
                  label="label"
                  placeholder="Choose Status"
                  @input="reloadFilteredData"
                />
              </div>
              <div class="col-md-4 mb-2">
                <label class="form-label">Approval</label>
                <v-select
                  v-model="filters.approval_step"
                  :options="approvalStepOptions"
                  :reduce="option => option.value"
                  label="label"
                  placeholder="Choose Approval"
                  @input="reloadFilteredData"
                />
              </div>
              <div class="col-md-4 mb-2">
                <label class="form-label">Course Type</label>
                <v-select
                  v-model="filters.course_type"
                  :options="courseTypeOptions"
                  :reduce="option => option.value"
                  label="label"
                  placeholder="Choose Course Type"
                  @input="reloadFilteredData"
                />
              </div>
            </div>
          </div>

          <div v-if="activeFiltersCount > 0" class="mb-3">
            <div class="d-flex flex-wrap align-items-center">
              <small class="text-muted mr-2">Active Filters:</small>

              <span v-if="filters.status" class="badge bg-light text-dark border mr-2 mb-1">
                Status: {{ statusFilterLabel }}
                <button type="button" class="btn btn-link p-0 ml-1" @click="clearSingleFilter('status')">×</button>
              </span>
              <span v-if="filters.approval_step" class="badge bg-light text-dark border mr-2 mb-1">
                Approval: {{ approvalStepLabel }}
                <button type="button" class="btn btn-link p-0 ml-1" @click="clearSingleFilter('approval_step')">×</button>
              </span>
              <span v-if="filters.course_type" class="badge bg-light text-dark border mr-2 mb-1">
                Course Type: {{ courseTypeLabel }}
                <button type="button" class="btn btn-link p-0 ml-1" @click="clearSingleFilter('course_type')">×</button>
              </span>
              <button type="button" class="btn btn-sm btn-link text-danger p-0 mb-1" @click="resetFilters">
                Clear All
              </button>
            </div>
          </div>

          <Steps :activeStep="1" />
          <div v-if="activeTab === 'structured'">
            <Structured
              :activeTab="activeTab"
              :selectedItems="selectedItems.structured"
              :isLoadingSummary="isLoadingSummary"
              :summaryData="summaryData"
              :isLoadingTNA="isLoadingTNA"
              :isLoadingModal="isLoadingModal"
              :gapCompetencies="structuredLearningData.gap_competencies"
              :mandatoryTrainings="structuredLearningData.mandatory_trainings"
              :handleOpenModalDetail="handleOpenModalDetail"
              :showDetailModal="showDetailModal"
              :showDetailModalCompetency="showDetailModalCompetency"
              :dataModal="dataModal"
              :dataModalCompetency="dataModalCompetency"
              @select-change="handleSelectChange"
              @close-detail="
                showDetailModal = false;
                showDetailModalCompetency = false;
                dataModal = null;
              "
            />
          </div>
          <div v-if="activeTab === 'social'">
            <Social
              :isLoadingSummary="isLoadingSummary"
              :isLoadingTNA="isLoadingTNA"
              :isLoadingModal="isLoadingModal"
              :activeTab="activeTab"
              :summaryData="summaryData"
              :socialLearningData="socialLearningData"
              :selectedItems="selectedItems.social"
              :handleOpenModalDetail="handleOpenModalDetail"
              :showDetailModal="showDetailModal"
              :dataModal="dataModal"
              @close-detail="
                showDetailModal = false;
                dataModal = null;
              "
              @select-change="handleSelectChange"
            />
          </div>
          <div v-if="activeTab === 'experiential'">
            <Experiential
              :isLoadingSummary="isLoadingSummary"
              :isLoadingTNA="isLoadingTNA"
              :isLoadingModal="isLoadingModal"
              :activeTab="activeTab"
              :summaryData="summaryData"
              :experientialLearningData="experientialLearningData"
              :handleOpenModalDetail="handleOpenModalDetail"
              :showDetailModal="showDetailModal"
              :dataModal="dataModal"
              @close-detail="
                showDetailModal = false;
                dataModal = null;
              "
              @select-change="handleSelectChange"
            />
          </div>
        </div>
        <!-- Button Submit -->
        <div class="card-footer d-flex justify-content-end">
          <b-button
            variant="primary"
            @click="
              {
                showDetailModal = false;
                showDetailModalCompetency = false;
                showConfirmationSubmit = true;
              }
            "
            :disabled="isSubmitting"
          >
            Submit
          </b-button>
        </div>
        <ConfirmationSubmit
          :showConfirmationSubmit="showConfirmationSubmit"
          @close="showConfirmationSubmit = false"
          :activeTab="activeTab"
          :selectedItems="selectedItems"
          :isSubmitting="isSubmitting"
          @submit="handleSubmit"
        />

        <AddSocial v-model="showAddSocialModal" />

        <AddExperiential v-model="showAddExperientialModal" :selectTeams="[]" @refreshData="handleRefreshExperiential" />

      </div>
    </div>
  </div>
</template>

<script>
import TNALogic from "./mytna.logic";
import ButtonAdd from "./components/button-add.vue";
import Header from "./components/header.vue";
import SelectedPeriod from "./components/selected-period.vue";
import Tabs from "./components/tabs.vue";
import Structured from "./components/structured.vue";
import Social from "./components/social.vue";
import Experiential from "./components/experiential.vue";
import ConfirmationSubmit from "./modal/ConfirmationSubmit.vue";
import Steps from "./components/steps.vue";
import AddSocial from "./modal/AddSocial.vue";
import AddExperiential from "./modal/AddExperiential.vue";
import { tabName } from "./utils/constant";

export default {
  name: "MyTNAPage",
  components: {
    ButtonAdd,
    Header,
    SelectedPeriod,
    Tabs,
    Steps,
    Structured,
    Social,
    Experiential,
    ConfirmationSubmit,
    AddSocial,
    AddExperiential,
  },
  mixins: [TNALogic], // semua logic di sini
  methods: {
    handleRefreshExperiential() {
      const payload = this.buildRequestPayload();
      this.fetchDataByTab(payload);
      this.fetchSummaryData(payload);
    },
  },
};
</script>
